interface SpecUnit {
	Code: string;
	IsDegrees?: boolean;
}

export const isGaugeSpecItem = (item: { Code: string; CategoryName: string }) =>
	item.CategoryName === "Go / No Go" && /^(?:[5-9]|1[0-4])$/.test(item.Code);

export const isAngleSpecItem = (item: SpecUnit) =>
	item.Code === "LA1" || item.Code === "LA2" || item.IsDegrees === true;
